import React, { useState, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { exportToCSV, exportToExcel, exportToPDF } from '../utils/Exports';
import { parseValue } from '../utils/Common';
import $ from 'jquery';
import moment from 'moment';
import Table from './common/Table';

const common = require('../utils/Common');

const UserRefeanceDetails = () => {
    const location = useLocation();
    const [userData, setUserData] = useState([]);
    const {userId}  = location.state || {}
    const [orderDetails, setOrderDetails] = useState([]);
    const [modal, setModal] = useState(false);
    const [commissionPercentOnlineProduct, setCommissionPercentOnlineProduct] = useState(0);
    const [commissionPercentOfflineProduct, setCommissionPercentOfflineProduct] = useState(0);
    const [commissionPercentService, setCommissionPercentService] = useState(0);
    const [orderDetailsType, setOrderDetailsType] = useState(null);
    const [commissionType, setCommissionType] = useState('sale_retail');
    const [tdsPercent, setTdsPercent] = useState(0);
    const [userCommissions, setUserCommissions] = useState([]);

    const retainerColumns = [
        { accessor: 'reg_id', header: 'Reg Id' },
        { accessor: 'first_name', header: 'First Name' },
        { accessor: 'last_name', header: 'Last Name' },

        {
            accessor: 'retainer_order_amount_online',
            header: 'Total Shopping Online Product',
            render: row => parseValue(row.retainer_order_amount_online, 'float')
        },
        {
            accessor: 'retainer_taxable_order_amount_online',
            header: 'Total Taxable Shopping Online Product',
            render: row => parseValue(row.retainer_taxable_order_amount_online, 'float')
        },
        {
            accessor: 'retainer_commission_percent_online',
            header: 'Commission Percent Online Product',
            render: row => parseValue(row.retainer_commission_percent_online, 'float')
        },
        {
            accessor: 'retainer_commission_online',
            header: 'Commission Online Product',
            render: row => parseValue(row.retainer_commission_online, 'float')
        },

        {
            accessor: 'retainer_order_amount_offline',
            header: 'Total Shopping Offline Product',
            render: row => parseValue(row.retainer_order_amount_offline, 'float')
        },
        {
            accessor: 'retainer_taxable_order_amount_offline',
            header: 'Total Taxable Shopping Offline Product',
            render: row => parseValue(row.retainer_taxable_order_amount_offline, 'float')
        },
        {
            accessor: 'retainer_commission_percent_offline',
            header: 'Commission Percent Offline Product',
            render: row => parseValue(row.retainer_commission_percent_offline, 'float')
        },
        {
            accessor: 'retainer_commission_offline',
            header: 'Commission Offline Product',
            render: row => parseValue(row.retainer_commission_offline, 'float')
        },

        {
            accessor: 'retainer_order_amount_service',
            header: 'Total Shopping Service',
            render: row => parseValue(row.retainer_order_amount_service, 'float')
        },
        {
            accessor: 'retainer_taxable_order_amount_service',
            header: 'Total Taxable Shopping Service',
            render: row => parseValue(row.retainer_taxable_order_amount_service, 'float')
        },
        {
            accessor: 'retainer_commission_percent_service',
            header: 'Commission Percent Service',
            render: row => parseValue(row.retainer_commission_percent_service, 'float')
        },
        {
            accessor: 'retainer_commission_service',
            header: 'Commission Service',
            render: row => parseValue(row.retainer_commission_service, 'float')
        },

        {
            accessor: 'total_commission',
            header: 'Total Commission',
            render: row => {
            const online = parseFloat(row.retainer_commission_online) || 0;
            const offline = parseFloat(row.retainer_commission_offline) || 0;
            const service = parseFloat(row.retainer_commission_service) || 0;
            return (online + offline + service).toFixed(2);
            }
        },
        {
            accessor: 'tds',
            header: 'TDS',
            render: row => {
            const online = parseFloat(row.retainer_commission_online) || 0;
            const offline = parseFloat(row.retainer_commission_offline) || 0;
            const service = parseFloat(row.retainer_commission_service) || 0;
            const total = online + offline + service;
            return (total * row.tds_percent).toFixed(2);
            }
        },
        {
            accessor: 'receiveable_commission',
            header: 'Receivable Commission',
            render: row => {
            const online = parseFloat(row.retainer_commission_online) || 0;
            const offline = parseFloat(row.retainer_commission_offline) || 0;
            const service = parseFloat(row.retainer_commission_service) || 0;
            const total = online + offline + service;
            const tds = total * row.tds_percent;
            return (total - tds).toFixed(2);
            }
        },
        {
            accessor: 'actions',
            header: 'Actions',
            render: row => (
            <button
                className="btn btn-primary btn-sm"
                onClick={() =>
                getOrderDetails(
                    row.order_item_ids,
                    row.retainer_commission_percent_online,
                    row.retainer_commission_percent_offline,
                    row.retainer_commission_percent_service,
                    'retainer',
                    row.tds_percent
                )
                }
            >
                View Order Details
            </button>
            )
        }
    ];


    const saleRetailColumns = [
        { accessor: 'reg_id', header: 'Reg Id' },
        { accessor: 'first_name', header: 'First Name' },
        { accessor: 'middle_name', header: 'Middle Name' },
        { accessor: 'last_name', header: 'Last Name' },

        {
            accessor: 'total_user_shopping_amount_taxable',
            header: 'User Total Taxable Shopping',
            render: row => parseValue(row.total_user_shopping_amount_taxable, 'float')
        },
        { accessor: 'variant', header: 'Variant' },

        {
            accessor: 'total_shopping_online_product',
            header: 'Total Shopping Online Product',
            render: row => parseValue(row.total_shopping_online_product, 'float')
        },
        {
            accessor: 'total_taxable_shopping_online_product',
            header: 'Total Taxable Shopping Online Product',
            render: row => parseValue(row.total_taxable_shopping_online_product, 'float')
        },
        {
            accessor: 'commission_percent_online_product',
            header: 'Commission Percent Online Product',
            render: row => parseValue(row.commission_percent_online_product, 'float')
        },

        {
            accessor: 'total_shopping_offline_product',
            header: 'Total Shopping Offline Product',
            render: row => parseValue(row.total_shopping_offline_product, 'float')
        },
        {
            accessor: 'total_taxable_shopping_offline_product',
            header: 'Total Taxable Shopping Offline Product',
            render: row => parseValue(row.total_taxable_shopping_offline_product, 'float')
        },
        {
            accessor: 'commission_percent_offline_product',
            header: 'Commission Percent Offline Product',
            render: row => parseValue(row.commission_percent_offline_product, 'float')
        },

        {
            accessor: 'total_shopping_service',
            header: 'Total Shopping Service',
            render: row => parseValue(row.total_shopping_service, 'float')
        },
        {
            accessor: 'total_taxable_shopping_service',
            header: 'Total Taxable Shopping Service',
            render: row => parseValue(row.total_taxable_shopping_service, 'float')
        },
        {
            accessor: 'commission_percent_service',
            header: 'Commission Percent Service',
            render: row => parseValue(row.commission_percent_service, 'float')
        },

        { accessor: 'ref_user_reg_id', header: 'Referral User Id' },

        {
            accessor: 'total_order_amount_shopping_online_product',
            header: 'Total Order Amount Shopping Online Product',
            render: row => parseValue(row.total_order_amount_shopping_online_product, 'float')
        },
        {
            accessor: 'total_taxable_amount_shopping_online_product',
            header: 'Taxable Order Amount Shopping Online Product',
            render: row => parseValue(row.total_taxable_amount_shopping_online_product, 'float')
        },
        {
            accessor: 'commission_shopping_online_product',
            header: 'Commission Shopping Online Product',
            render: row => parseValue(row.commission_shopping_online_product, 'float')
        },

        {
            accessor: 'total_order_amount_shopping_offline_product',
            header: 'Total Order Amount Shopping Offline Product',
            render: row => parseValue(row.total_order_amount_shopping_offline_product, 'float')
        },
        {
            accessor: 'total_taxable_amount_shopping_offline_product',
            header: 'Taxable Order Amount Shopping Offline Product',
            render: row => parseValue(row.total_taxable_amount_shopping_offline_product, 'float')
        },
        {
            accessor: 'commission_shopping_offline_product',
            header: 'Commission Shopping Offline Product',
            render: row => parseValue(row.commission_shopping_offline_product, 'float')
        },

        {
            accessor: 'total_order_amount_shopping_service',
            header: 'Total Order Amount Shopping Service',
            render: row => parseValue(row.total_order_amount_shopping_service, 'float')
        },
        {
            accessor: 'total_taxable_amount_shopping_service',
            header: 'Taxable Order Amount Shopping Service',
            render: row => parseValue(row.total_taxable_amount_shopping_service, 'float')
        },
        {
            accessor: 'commission_shopping_service',
            header: 'Commission Shopping Service',
            render: row => parseValue(row.commission_shopping_service, 'float')
        },

        {
            accessor: 'shopping_tds',
            header: 'TDS Shopping',
            render: row => {
            const online = parseFloat(row.commission_shopping_online_product) || 0;
            const offline = parseFloat(row.commission_shopping_offline_product) || 0;
            const service = parseFloat(row.commission_shopping_service) || 0;
            return ((online + offline + service) * row.tds_percent).toFixed(2);
            }
        },
        {
            header: 'Receivable Shopping',
            accessor: 'receivable_shopping',
            render: row => {
            const total = 
                parseFloat(row.commission_shopping_online_product || 0) +
                parseFloat(row.commission_shopping_offline_product || 0) +
                parseFloat(row.commission_shopping_service || 0);
            return parseValue((total - total * 0.10).toFixed(2), 'float');
            }
        },

        {
            accessor: 'total_order_amount_retail_online_product',
            header: 'Total Order Amount Retail Online Product',
            render: row => parseValue(row.total_order_amount_retail_online_product, 'float')
        },
        {
            accessor: 'total_taxable_amount_retail_online_product',
            header: 'Taxable Order Amount Retail Online Product',
            render: row => parseValue(row.total_taxable_amount_retail_online_product, 'float')
        },
        {
            accessor: 'commission_percent_retail_online_product',
            header: 'Commission Percent Retail Online Product',
            render: row => parseValue(row.commission_percent_retail_online_product, 'float')
        },
        {
            accessor: 'commission_retail_online_product',
            header: 'Commission Retail Online Product',
            render: row => parseValue(row.commission_retail_online_product, 'float')
        },

        {
            accessor: 'total_order_amount_retail_offline_product',
            header: 'Total Order Amount Retail Offline Product',
            render: row => parseValue(row.total_order_amount_retail_offline_product, 'float')
        },
        {
            accessor: 'total_taxable_amount_retail_offline_product',
            header: 'Taxable Order Amount Retail Offline Product',
            render: row => parseValue(row.total_taxable_amount_retail_offline_product, 'float')
        },
        {
            accessor: 'commission_percent_retail_offline_product',
            header: 'Commission Percent Retail Offline Product',
            render: row => parseValue(row.commission_percent_retail_offline_product, 'float')
        },
        {
            accessor: 'commission_retail_offline_product',
            header: 'Commission Retail Offline Product',
            render: row => parseValue(row.commission_retail_offline_product, 'float')
        },

        {
            accessor: 'total_order_amount_retail_service',
            header: 'Total Order Amount Retail Service',
            render: row => parseValue(row.total_order_amount_retail_service, 'float')
        },
        {
            accessor: 'total_taxable_amount_retail_service',
            header: 'Taxable Order Amount Retail Service',
            render: row => parseValue(row.total_taxable_amount_retail_service, 'float')
        },
        {
            accessor: 'commission_percent_retail_service',
            header: 'Commission Percent Retail Service',
            render: row => parseValue(row.commission_percent_retail_service, 'float')
        },
        {
            accessor: 'commission_retail_service',
            header: 'Commission Retail Service',
            render: row => parseValue(row.commission_retail_service, 'float')
        },

        {
            accessor: 'retail_tds',
            header: 'TDS Retail',
            render: row => {
            const online = parseFloat(row.commission_retail_online_product) || 0;
            const offline = parseFloat(row.commission_retail_offline_product) || 0;
            const service = parseFloat(row.commission_retail_service) || 0;
            return ((online + offline + service) * row.tds_percent).toFixed(2);
            }
        },
        {
            accessor: 'retail_receiveable',
            header: 'Receivable Retail',
            render: row => {
            const online = parseFloat(row.commission_retail_online_product) || 0;
            const offline = parseFloat(row.commission_retail_offline_product) || 0;
            const service = parseFloat(row.commission_retail_service) || 0;
            const total = online + offline + service;
            return (total - total * row.tds_percent).toFixed(2);
            }
        },

        {
            accessor: 'actions',
            header: 'Actions',
            render: row => (
            <div className="d-flex flex-column">
                {row.order_item_ids_shopping && (
                <button
                    className="btn btn-primary btn-sm mb-2"
                    onClick={() =>
                    getOrderDetails(
                        row.order_item_ids_shopping,
                        row.commission_percent_online_product,
                        row.commission_percent_offline_product,
                        row.commission_percent_service,
                        'shopping',
                        row.tds_percent
                    )
                    }
                >
                    View Shopping Order Details
                </button>
                )}
                {row.order_item_ids_retail && (
                <button
                    className="btn btn-primary btn-sm"
                    onClick={() =>
                    getOrderDetails(
                        row.order_item_ids_retail,
                        row.commission_percent_retail_online_product,
                        row.commission_percent_retail_offline_product,
                        row.commission_percent_retail_service,
                        'retail',
                        row.tds_percent
                    )
                    }
                >
                    View Retail Order Details
                </button>
                )}
            </div>
            )
        }
    ];


    const orderDetailsColumns = [
        {
            accessor: 'order_id',
            header: 'Order Id',
            render: row => row.order?.order_id || 'NA'
        },
        {
            accessor: 'reg_id',
            header: 'Reg Id',
            render: row => row.order?.user?.reg_id || 'NA'
        },
        {
            accessor: 'order_date',
            header: 'Order Date',
            render: row => row.order?.created_at || 'NA'
        },
        {
            accessor: 'invoice_no',
            header: 'Invoice No',
            render: row => {
            const invoices = row.order?.invoices;
            const invoiceType = ['shopping', 'retainer'].includes(orderDetailsType) ? 'product' : 'seller_product';
            return invoices?.find(inv => inv.invoice_type === invoiceType)?.invoice_no || 'NA';
            }
        },
        {
            accessor: 'no_return_date',
            header: 'No Return Date',
            render: row => row?.no_return_date || null
        },
        {
            accessor: 'product_name',
            header: 'Product/Service Name',
            render: row =>
            row.product_item?.product?.name ||
            row.offline_sale_product_datum?.product_description ||
            row.seller_service?.service_name || 'NA'
        },
        {
            accessor: 'online_sale_amount',
            header: 'Online Sale Amount',
            render: row => row.product_id ? Number(row.order_price).toFixed(2) : '0.00'
        },
        {
            accessor: 'online_taxable_amount',
            header: 'Online Taxable Amount',
            render: row => row.product_id ? row.taxable_amount : 0
        },
        {
            accessor: 'logistics_amount',
            header: 'Logistics Amount',
            render: row => {
            const logisticsOrder = row.logistics_order || row.logistics_orders?.[0] || {};
            const itemCount = logisticsOrder.order_item_id?.split(',')?.length || 0;
            return safeDivide(safeNumber(logisticsOrder.order_price), itemCount);
            }
        },
        {
            accessor: 'logistics_taxable_amount',
            header: 'Logistics Taxable Amount',
            render: row => {
            const logisticsOrder = row.logistics_order || row.logistics_orders?.[0] || {};
            const itemCount = logisticsOrder.order_item_id?.split(',')?.length || 0;
            return safeDivide(safeNumber(logisticsOrder.taxable_value), itemCount);
            }
        },
        {
            accessor: 'commission_percent_online',
            header: 'Commission Percent Online',
            render: row => row.product_id ? commissionPercentOnlineProduct : 0
        },
        {
            accessor: 'commission_online',
            header: 'Commission Online',
            render: row => {
            const taxable = safeNumber(row.taxable_amount);
            const logistics = row.logistics_order || row.logistics_orders?.[0] || {};
            const count = logistics.order_item_id?.split(',')?.length || 0;
            const logisticsTaxable = safeDivide(safeNumber(logistics.taxable_value), count);

            const percent = row.product_id ? commissionPercentOnlineProduct : 0;
            const productCommission = (taxable * percent) / 100;
            const logisticsCommission = (logisticsTaxable * commissionPercentService) / 100;

            return (productCommission + logisticsCommission).toFixed(2);
            }
        },
        {
            accessor: 'offline_sale_amount',
            header: 'Offline Sale Amount',
            render: row => row.offline_sale_id && row.offline_sale_product_datum
            ? row.offline_sale_product_datum.sale_amount : 0
        },
        {
            accessor: 'offline_taxable_amount',
            header: 'Offline Taxable Amount',
            render: row => row.offline_sale_id && row.offline_sale_product_datum
            ? row.offline_sale_product_datum.taxable_supply : 0
        },
        {
            accessor: 'commission_percent_offline',
            header: 'Commission Percent Offline',
            render: row => row.offline_sale_id ? commissionPercentOfflineProduct : 0
        },
        {
            accessor: 'commission_offline',
            header: 'Commission Offline',
            render: row => {
            const taxable = safeNumber(row.taxable_amount);
            const percent = row.offline_sale_id ? commissionPercentOfflineProduct : 0;
            return ((taxable * percent) / 100).toFixed(2);
            }
        },
        {
            accessor: 'service_sale_amount',
            header: 'Service Sale Amount',
            render: row => row.service_id ? row.order_price : 0
        },
        {
            accessor: 'service_taxable_amount',
            header: 'Service Taxable Amount',
            render: row => row.service_id ? safeNumber(row.taxable_amount) : 0
        },
        {
            accessor: 'commission_percent_service',
            header: 'Commission Percent Service',
            render: row =>
            row.service_id || row.logistics_order || row.logistics_orders?.length > 0
                ? commissionPercentService
                : 0
        },
        {
            accessor: 'commission_service',
            header: 'Commission Service',
            render: row => {
            const taxable = safeNumber(row.taxable_amount);
            const percent = row.service_id ? commissionPercentService : 0;
            return ((taxable * percent) / 100).toFixed(2);
            }
        },
        {
            accessor: 'commission',
            header: 'Commission',
            render: row => {
            const taxable = safeNumber(row.taxable_amount);
            const logistics = row.logistics_order || row.logistics_orders?.[0] || {};
            const count = logistics.order_item_id?.split(',')?.length || 0;
            const logisticsTaxable = safeDivide(safeNumber(logistics.taxable_value), count);

            const percent = row.product_id
                ? commissionPercentOnlineProduct
                : row.offline_sale_id
                ? commissionPercentOfflineProduct
                : commissionPercentService;

            const productCommission = (taxable * percent) / 100;
            const logisticsCommission = (logisticsTaxable * commissionPercentService) / 100;
            return (productCommission + logisticsCommission).toFixed(2);
            }
        },
        {
            accessor: 'tds',
            header: 'TDS',
            render: row => {
            const taxable = safeNumber(row.taxable_amount);
            const logistics = row.logistics_order || row.logistics_orders?.[0] || {};
            const count = logistics.order_item_id?.split(',')?.length || 0;
            const logisticsTaxable = safeDivide(safeNumber(logistics.taxable_value), count);

            const percent = row.product_id
                ? commissionPercentOnlineProduct
                : row.offline_sale_id
                ? commissionPercentOfflineProduct
                : commissionPercentService;

            const commission = (taxable * percent + logisticsTaxable * commissionPercentService) / 100;
            return (commission * tdsPercent).toFixed(2);
            }
        },
        {
            accessor: 'net_receivable',
            header: 'Net Receivable',
            render: row => {
            const taxable = safeNumber(row.taxable_amount);
            const logistics = row.logistics_order || row.logistics_orders?.[0] || {};
            const count = logistics.order_item_id?.split(',')?.length || 0;
            const logisticsTaxable = safeDivide(safeNumber(logistics.taxable_value), count);

            const percent = row.product_id
                ? commissionPercentOnlineProduct
                : row.offline_sale_id
                ? commissionPercentOfflineProduct
                : commissionPercentService;

            const commission = (taxable * percent + logisticsTaxable * commissionPercentService) / 100;
            const tds = commission * tdsPercent;
            return (commission - tds).toFixed(2);
            }
        }
    ];

    
    const fetchUserCommissions = async () => {
        setUserCommissions([]);
        if (!$('#start_date').val() || !$('#end_date').val() || !$('#commission_type').val()) {
            alert("Fill all filters (Start Date, End Date & Commission Type)");
            return;
        }
        setCommissionType($('#commission_type').val());
        let fetchType = 0;
        if ($('#fetch_approved').is(':checked')) {
          fetchType = 1;
        } else if ($('#fetch_done_payments').is(':checked')) {
          fetchType = 2;
        }
        const data = {
            start_date: $('#start_date').val(),
            end_date: $('#end_date').val(),
            user_id: userId,
            fetch_approved: fetchType,
            retainer_commission: $('#commission_type').val() == "retainer" ? 1 : 0
        }
            let response = await common.apiRequest('post', '/admin/fetch-user-commission', data);
            if (response.status == 200) {
                if (response.data.code == 'success') {
                    setUserCommissions(response.data.data);
                } else {
                    alert(response.data.error);
                }
            } else {
                alert(response.data.error);
            }
        }

    const toggle = () => {
        setModal(!modal);
        setOrderDetails([]);
        setCommissionPercentOnlineProduct(0);
        setCommissionPercentOfflineProduct(0);
        setCommissionPercentService(0);
        setOrderDetailsType(null);
    }

    const getOrderDetails = async (orderIds, commissionPercentOnlineProduct, commissionPercentOfflineProduct, commissionPercentService, type, tds) => {
        let data = {
            'ids': orderIds,
        }
        let response = await common.apiRequest('post', '/orders/get-order-by-order-id', data);
        if (response.status == 200) {
            if (response.data.code == 'success') {
                setOrderDetails(response.data.data);
                setModal(true);
                setCommissionPercentOnlineProduct(commissionPercentOnlineProduct);
                setCommissionPercentOfflineProduct(commissionPercentOfflineProduct);
                setCommissionPercentService(commissionPercentService);
                setTdsPercent(tds);
                setOrderDetailsType(type);
            } else {
                alert(response.data.error);
            }
        } else {
            alert(response.data.error);
        }
    }
    const rowHeight = 80;
    const retainerColumnDefsdata = userCommissions.map((item, index) => ({
        "S.No": index + 1,
        reg_id: item.reg_id,
        first_name: item.first_name,
        middle_name: item.middle_name,
        last_name: item.last_name,
        bank_account_no: item.bank_account_no || "",
        bank_name: item.bank_name || "",
        ifsc_code: item.ifsc_code || "",
        retainer_total_order_amount_online: parseValue(item.retainer_total_order_amount_online, 'float'),
        retainer_total_taxable_order_amount_online: parseValue(item.retainer_total_taxable_order_amount_online, 'float'),
        retainer_total_order_amount_offline: parseValue(item.retainer_total_order_amount_offline, 'float'),
        retainer_total_taxable_order_amount_offline: parseValue(item.retainer_total_taxable_order_amount_offline, 'float'),
        retainer_total_order_amount_service: parseValue(item.retainer_total_order_amount_service, 'float'),
        retainer_total_taxable_order_amount_service: parseValue(item.retainer_total_taxable_order_amount_service, 'float'),
        refer_reg_id: item.refer_reg_id,
        refer_first_name: item.refer_first_name,
        refer_middle_name: item.refer_middle_name,
        refer_last_name: item.refer_last_name,
        retainer_order_amount_online: parseValue(item.retainer_order_amount_online, 'float'),
        retainer_taxable_order_amount_online: parseValue(item.retainer_taxable_order_amount_online, 'float'),
        retainer_commission_percent_online: parseValue(item.retainer_commission_percent_online, 'float'),
        retainer_commission_online: parseValue(item.retainer_commission_online, 'float'),
        retainer_order_amount_offline: parseValue(item.retainer_order_amount_offline, 'float'),
        retainer_taxable_order_amount_offline: parseValue(item.retainer_taxable_order_amount_offline, 'float'),
        retainer_commission_percent_offline: parseValue(item.retainer_commission_percent_offline, 'float'),
        retainer_commission_offline: parseValue(item.retainer_commission_offline, 'float'),
        retainer_order_amount_service: parseValue(item.retainer_order_amount_service, 'float'),
        retainer_taxable_order_amount_service: parseValue(item.retainer_taxable_order_amount_service, 'float'),
        retainer_commission_percent_service: parseValue(item.retainer_commission_percent_service, 'float'),
        retainer_commission_service: parseValue(item.retainer_commission_service, 'float'),
        total_commission: parseValue(
            (
                parseFloat(item.retainer_commission_online || 0) +
                parseFloat(item.retainer_commission_offline || 0) +
                parseFloat(item.retainer_commission_service || 0)
            ).toFixed(2),
            'float'
        ),
        tds: parseValue(
            (
                (parseFloat(item.retainer_commission_online) || 0) +
                (parseFloat(item.retainer_commission_offline) || 0) +
                (parseFloat(item.retainer_commission_service) || 0)
            ) * item.tds_percent, 
            'float'
        ),
        receivable_commission: parseValue(
            (
                parseFloat(item.retainer_commission_online || 0) +
                parseFloat(item.retainer_commission_offline || 0) +
                parseFloat(item.retainer_commission_service || 0) -
                (
                    (
                        parseFloat(item.retainer_commission_online || 0) +
                        parseFloat(item.retainer_commission_offline || 0) +
                        parseFloat(item.retainer_commission_service || 0)
                    ) * item.tds_percent
                )
            ).toFixed(2),
            'float'
        )
    }));
    
    const saleRetailColumnDefsdata = userCommissions.map((user, index) => ({
        "S.No": index + 1,
        reg_id: user.reg_id || "",
        first_name: user.first_name || "",
        middle_name: user.middle_name || "",
        last_name: user.last_name || "",
        total_user_shopping_amount_taxable: parseValue(user.total_user_shopping_amount_taxable, 'float'),
        variant: user.variant || "",
        total_shopping_online_product: parseValue(user.total_shopping_online_product, 'float'),
        total_taxable_shopping_online_product: parseValue(user.total_taxable_shopping_online_product, 'float'),
        commission_percent_online_product: parseValue(user.commission_percent_online_product, 'float'),
        total_shopping_offline_product: parseValue(user.total_shopping_offline_product, 'float'),
        total_taxable_shopping_offline_product: parseValue(user.total_taxable_shopping_offline_product, 'float'),
        commission_percent_offline_product: parseValue(user.commission_percent_offline_product, 'float'),
        total_shopping_service: parseValue(user.total_shopping_service, 'float'),
        total_taxable_shopping_service: parseValue(user.total_taxable_shopping_service, 'float'),
        commission_percent_service: parseValue(user.commission_percent_service, 'float'),
        ref_user_reg_id: user.ref_user_reg_id || "",
        total_order_amount_shopping_online_product: parseValue(user.total_order_amount_shopping_online_product, 'float'),
        total_taxable_amount_shopping_online_product: parseValue(user.total_taxable_amount_shopping_online_product, 'float'),
        commission_shopping_online_product: parseValue(user.commission_shopping_online_product, 'float'),
        total_order_amount_shopping_offline_product: parseValue(user.total_order_amount_shopping_offline_product, 'float'),
        total_taxable_amount_shopping_offline_product: parseValue(user.total_taxable_amount_shopping_offline_product, 'float'),
        commission_shopping_offline_product: parseValue(user.commission_shopping_offline_product, 'float'),
        total_order_amount_shopping_service: parseValue(user.total_order_amount_shopping_service, 'float'),
        total_taxable_amount_shopping_service: parseValue(user.total_taxable_amount_shopping_service, 'float'),
        commission_shopping_service: parseValue(user.commission_shopping_service, 'float'),
        shopping_tds: parseValue(
            (
                (parseFloat(user.commission_shopping_online_product) || 0) +
                (parseFloat(user.commission_shopping_offline_product) || 0) +
                (parseFloat(user.commission_shopping_service) || 0)
            ) * user.tds_percent, 
            'float'
        ),
        Receiveable_Shopping: parseValue(
            (
                (parseFloat(user.commission_shopping_online_product) || 0) +
                (parseFloat(user.commission_shopping_offline_product) || 0) +
                (parseFloat(user.commission_shopping_service) || 0) -
                (
                    ((parseFloat(user.commission_shopping_online_product) || 0) +
                    (parseFloat(user.commission_shopping_offline_product) || 0) +
                    (parseFloat(user.commission_shopping_service) || 0)) * 0.10
                )
            ).toFixed(2), 
            'float'
        ),
        total_order_amount_retail_online_product: parseValue(user.total_order_amount_retail_online_product, 'float'),
        total_taxable_amount_retail_online_product: parseValue(user.total_taxable_amount_retail_online_product, 'float'),
        commission_percent_retail_online_product: parseValue(user.commission_percent_retail_online_product, 'float'),
        commission_retail_online_product: parseValue(user.commission_retail_online_product, 'float'),
        total_order_amount_retail_offline_product: parseValue(user.total_order_amount_retail_offline_product, 'float'),
        total_taxable_amount_retail_offline_product: parseValue(user.total_taxable_amount_retail_offline_product, 'float'),
        commission_percent_retail_offline_product: parseValue(user.commission_percent_retail_offline_product, 'float'),
        commission_retail_offline_product: parseValue(user.commission_retail_offline_product, 'float'),
        total_order_amount_retail_service: parseValue(user.total_order_amount_retail_service, 'float'),
        total_taxable_amount_retail_service: parseValue(user.total_taxable_amount_retail_service, 'float'),
        commission_percent_retail_service: parseValue(user.commission_percent_retail_service, 'float'),
        commission_retail_service: parseValue(user.commission_retail_service, 'float'),
        retail_tds: parseValue(
            (
                (parseFloat(user.commission_retail_online_product) || 0) +
                (parseFloat(user.commission_retail_offline_product) || 0) +
                (parseFloat(user.commission_retail_service) || 0)
            ) * user.tds_percent, 
            'float'
        ),
        retail_receiveable: parseValue(
            (
                (parseFloat(user.commission_retail_online_product) || 0) +
                (parseFloat(user.commission_retail_offline_product) || 0) +
                (parseFloat(user.commission_retail_service) || 0) -
                (
                    ((parseFloat(user.commission_retail_online_product) || 0) +
                    (parseFloat(user.commission_retail_offline_product) || 0) +
                    (parseFloat(user.commission_retail_service) || 0)) * user.tds_percent
                )
            ).toFixed(2), 
            'float'
        )
    }));
    const safeDivide = (num, denom) => denom > 0 ? num / denom : 0;
    const safeNumber = val => Number(val) || 0;
    const dataOther = orderDetails.map((data, index) => {
        const onlineTaxableAmount = data.product_id ? safeNumber(data.taxable_amount) : 0;
        const offlineTaxableAmount = data.offline_sale_id && data.offline_sale_product_datum 
            ? safeNumber(data.offline_sale_product_datum.taxable_supply) 
            : 0;
        const serviceTaxableAmount = data.service_id ? safeNumber(data.taxable_amount) : 0;
    
        const logisticsOrder = data.logistics_order || data?.logistics_orders?.[0] || {};
        const logisticsItemCount = logisticsOrder?.order_item_id?.split(',')?.length || 0;
        const logisticsTaxableAmount = safeDivide(safeNumber(logisticsOrder.taxable_value), logisticsItemCount);
        const logisticsOrderAmount = safeDivide(safeNumber(logisticsOrder.order_price), logisticsItemCount);
    
        // Calculate commissions
        const onlineCommission = onlineTaxableAmount * commissionPercentOnlineProduct / 100;
        const offlineCommission = offlineTaxableAmount * commissionPercentOfflineProduct / 100;
        const serviceCommission = serviceTaxableAmount * commissionPercentService / 100;
        const logisticsCommission = logisticsTaxableAmount * commissionPercentService / 100;
    
        const totalCommission = onlineCommission + offlineCommission + serviceCommission + logisticsCommission;
        const tds = totalCommission * tdsPercent;
        const netReceivable = totalCommission - tds;
    
        return {
            "S.No": index + 1,
            "Order Id": data.order?.order_id || 'NA',
            'Reg Id': data.order?.user?.reg_id || 'NA',
            "Order Date": data.order?.created_at || 'NA',
            "Invoice No": data.order?.invoices?.find(invoice =>
                invoice.invoice_type === (["shopping", "retainer"].includes(orderDetailsType) ? 'product' : 'seller_product')
            )?.invoice_no || 'NA',
            "No Return Date": data?.no_return_date || null,
            "Product/Service Name": data.product_item?.product?.name 
                                    || data.offline_sale_product_datum?.product_description 
                                    || data.seller_service?.service_name 
                                    || 'NA',
            "Online Sale Amount": data.product_id ? safeNumber(data.order_price).toFixed(2) : "0.00",
            "Online Taxable Amount": onlineTaxableAmount,
            "Logistics Amount": logisticsOrderAmount,
            "Logistics Taxable Amount": logisticsTaxableAmount,
            "Commission Percent Online": commissionPercentOnlineProduct,
            "Commission Online": parseFloat(onlineCommission) + parseFloat(logisticsCommission),
            "Offline Sale Amount": data.offline_sale_id && data.offline_sale_product_datum 
                                    ? safeNumber(data.offline_sale_product_datum.sale_amount) 
                                    : 0,
            "Offline Taxable Amount": offlineTaxableAmount,
            "Commission Percent Offline": commissionPercentOfflineProduct,
            "Commission Offline": offlineCommission,
            "Service Sale Amount": data.service_id ? safeNumber(data.order_price) : 0,
            "Service Taxable Amount": serviceTaxableAmount,
            "Commission Percent Service Sale": commissionPercentService,
            "Commission Service": serviceCommission,
            "Commission": totalCommission.toFixed(2),
            "TDS": tds.toFixed(2),
            "Net Receivable": netReceivable.toFixed(2)
        };
    });
      
    const handleExportCSVs = () => {
      exportToCSV(dataOther, commissionType === 'retainer' ? "retainer order details" : "sale/Retail order details");
    }
      
    const handleExportExcels = () => {
      exportToExcel(dataOther, commissionType === 'retainer' ? "retainer order details" : "sale/Retail order details");
    }
      
    const handleExportPDFs = () => {
      exportToPDF(dataOther, commissionType === 'retainer' ? "retainer order details" : "sale/Retail order details");
    }        

    const handleMonthOrYearChange = () => {
        const month = parseInt(document.getElementById("month_selector").value);
        const year = parseInt(document.getElementById("year_selector").value);
    
        if (!isNaN(month) && !isNaN(year)) {
            const startDate = moment({ year, month: month - 1, day: 1 });
            const endDate = moment(startDate).endOf('month');
    
            document.getElementById("start_date").value = startDate.format('YYYY-MM-DD');
            document.getElementById("end_date").value = endDate.format('YYYY-MM-DD');
        }
    };

        
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <ol className="col-12 breadcrumb bg-transparent">
                        <li className="breadcrumb-item"><Link to="/" className="text-dark">Home</Link></li>
                        <li className="breadcrumb-item"><Link to="/my-account" className="text-dark">user-account</Link></li>
                        <li className="breadcrumb-item active"><Link to="#" className="text-dark">reffer info</Link></li>
                    </ol>
                </div>
            </div>

            <div className='row mb-4'>
                <div className='col-md-3'>
                    <label>Select Month</label>
                    <select className='form-control' id="month_selector" onChange={handleMonthOrYearChange}>
                        <option value="">-- Select Month --</option>
                        {Array.from({ length: 12 }, (_, i) => (
                            <option key={i + 1} value={i + 1}>
                                {moment().month(i).format("MMMM")}
                            </option>
                        ))}
                    </select>
                    <br />
                    <input type='radio' name='fetch_type' id="all" defaultChecked/> Fetch All&nbsp;&nbsp;
                   <input type='radio' name="fetch_type" id="fetch_approved"  /> Fetch Approved&nbsp;&nbsp;
                   <input type='radio' name="fetch_type" id="fetch_done_payments" /> Fetch Done Payments
                </div>

                <div className='col-md-3'>
                    <label>Select Year</label>
                    <select className='form-control' id="year_selector" onChange={handleMonthOrYearChange}>
                        <option value="">-- Select Year --</option>
                        {Array.from({ length: new Date().getFullYear() - 2025 + 1 }, (_, i) => {
                            const year = 2025 + i;
                            return <option key={year} value={year}>{year}</option>;
                        })}
                    </select>
                </div>

                <div className='col-md-3'>
                    <label>Commission Type</label>
                    <select id="commission_type" className='form-control'>
                        <option value="">Select Commission Type</option>
                        <option value="sale_retail">Sale/Retail Commission</option>
                        <option value="retainer">Retainer Commission</option>
                    </select>
                </div>

                <div className='col-md-3'>
                    <button type="button" className='btn btn-primary btn-sm mt-4' onClick={fetchUserCommissions}>Submit</button>
                </div>

                {/* Hidden fields for start and end date */}
                <input type="hidden" id="start_date" />
                <input type="hidden" id="end_date" />
            </div>


            <div className='mb-3'>
            <button className='btn btn-primary me-2' onClick={() => exportToCSV(commissionType === 'retainer' ? retainerColumnDefsdata : saleRetailColumnDefsdata, commissionType === 'retainer' ? "retainer commission" : "sale/Retail commission")}>Export to CSV</button>
                <button className='btn btn-primary me-2' onClick={() => exportToExcel(commissionType === 'retainer' ? retainerColumnDefsdata : saleRetailColumnDefsdata, commissionType === 'retainer' ? "retainer commission" : "sale/Retail commission")}>Export to Excel</button>
                <button className='btn btn-primary' onClick={() => exportToPDF(commissionType === 'retainer' ? retainerColumnDefsdata : saleRetailColumnDefsdata, commissionType === 'retainer' ? "retainer commission" : "sale/Retail commission")}>Export to PDF</button>
            </div>

            <div className="ag-theme-alpine" style={{ height: 600 }}>
                <Table 
                    columns={commissionType === 'retainer' ? retainerColumns : saleRetailColumns}
                    data={userCommissions}
                />
            </div>

            <Modal isOpen={modal} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle}>Order Details</ModalHeader>
                <ModalBody>
                    <div className='mb-3'>
                    <button className='btn btn-secondary me-2' onClick={handleExportCSVs}>Export to CSV</button>
                        <button className='btn btn-secondary me-2' onClick={handleExportExcels}>Export to Excel</button>
                        <button className='btn btn-secondary' onClick={handleExportPDFs}>Export to PDF</button>
                    </div>
                    
                    <div className="ag-theme-alpine" style={{ height: 400 }}>
                        <Table 
                            columns={orderDetailsColumns}
                            data={orderDetails}
                        />
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
};

export default UserRefeanceDetails;